import { BaseQuery } from "./_BaseQuery";

export class CompanyGroupQuery extends BaseQuery {
}
